
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"126.5","cy":"125.5","r":"95.5","fill":"#fff"}}),_c('path',{attrs:{"d":"M255 115.5C248.6 50.1 193.7.2 128 0 57.3 0 0 57.3 0 128s57.3 128 128 128c4.1 0 8.1-.2 12.1-.6 70.4-6.9 121.8-69.5 114.9-139.9zM57.3 172.8l3.5 3.5c-1.3-1-2.4-2.2-3.5-3.5zm10.3 7l-1.8-.6c-1.8-.7-3.4-1.7-4.9-2.9l-3.5-3.5c-1.6-2-2.8-4.3-3.5-6.7-3.3-12-3.3-37.1-3.3-37.1s0-25.2 3.2-37.2c.3-1.3.8-2.5 1.4-3.7 2.4-4.9 6.8-8.6 12.3-10.1 12.1-3.2 60.4-3.2 60.4-3.2s48.3 0 60.4 3.2c1.8.5 3.4 1.2 5 2.2 2.7 1.6 4.9 3.8 6.5 6.5 1 1.5 1.7 3.2 2.2 5 3.2 12 3.2 37.2 3.2 37.2v.1s0 25-3.2 37.1c-.5 2-1.4 3.9-2.6 5.7-.5.8-1.1 1.5-1.7 2.2-2.5 2.8-5.7 4.8-9.3 5.8-7.3 2-27.8 2.7-42.9 3h-1.9c-8.9.2-15.6.2-15.6.2s-48.3 0-60.4-3.2z"}}),_c('path',{attrs:{"d":"M112.5 105.7v46.4l.2-.1 39.9-23.1z"}})])
          )
        }
      }
    